import domReady from "@wordpress/dom-ready";
import { items } from "./data";

domReady(() => {
	const dropdownContainer = document.querySelector(
		".wp-block-qasas-companion-dropdown",
	);
	const dropdownToggle = dropdownContainer.querySelector(
		".wp-block-qasas-companion-dropdown-toggle",
	);
	const dropdownList = dropdownContainer.querySelector(
		".wp-block-qasas-companion-dropdown-items",
	);
	const titleText = dropdownContainer.querySelector(
		".wp-block-qasas-companion-dropdown-title",
	);
	const description = dropdownContainer.querySelector(
		".wp-block-qasas-companion-dropdown-description",
	);

	let isOpen = false;
	dropdownList.style.display = "none";

	// Initialize with the first item
	updateSelectedItem(items[0]);

	// Populate dropdown list
	items.forEach((item) => {
		const li = document.createElement("li");
		li.innerHTML = `<span>${item.icon}</span> <span>${item.title}</span>`;
		li.addEventListener("click", (event) => {
			event.stopPropagation(); // Add this line
			updateSelectedItem(item);
			closeDropdown();
		});
		dropdownList.appendChild(li);
	});

	// Toggle dropdown
	dropdownToggle.addEventListener("click", (event) => {
		event.stopPropagation(); // Add this line
		toggleDropdown();
	});

	// Add this event listener
	document.addEventListener("click", (event) => {
		if (!dropdownContainer.contains(event.target)) {
			closeDropdown();
		}
	});

	function toggleDropdown() {
		isOpen = !isOpen;
		dropdownList.style.display = isOpen ? "block" : "none";
	}

	// Add this new function
	function closeDropdown() {
		isOpen = false;
		dropdownList.style.display = "none";
	}

	function updateSelectedItem(item) {
		titleText.textContent = item.title;
		description.textContent = item.description;

		// Define an array of valid class names
		const validClasses = ['small', 'agency', 'saas'];

		// Remove all valid classes from the container
		validClasses.forEach(className => {
			dropdownContainer.classList.remove(className);
		});

		// Add the new class if it's valid
		if (validClasses.includes(item.className)) {
			dropdownContainer.classList.add(item.className);
		}
	}
});
